import { render, staticRenderFns } from "./SurfaceDamagesInput.vue?vue&type=template&id=610bcc54&scoped=true"
import script from "./SurfaceDamagesInput.vue?vue&type=script&lang=ts"
export * from "./SurfaceDamagesInput.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceDamagesInput.vue?vue&type=style&index=0&id=610bcc54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bcc54",
  null
  
)

export default component.exports